var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"msgcontainer",staticClass:"messenger-frame"},[_c('messenger-side-bar'),_vm._l((_vm.chatWindows),function(chatWindow,index){return _c('messenger-frame',{key:index,attrs:{"conversation-uid":chatWindow.uid}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }